// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__3To-5","container":"styles_container__3dpOB","table":"styles_table__xm5zi"};